import { Box } from 'native-base'

interface DeliveryStatusIconProps {
  children: React.ReactNode
  isError?: boolean
  isLatest?: boolean
}

export const DeliveryStatusIcon: React.FunctionComponent<DeliveryStatusIconProps> = ({
  children,
  isError,
  isLatest,
}) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    color={isError ? '#972626' : '#21211f'}
    bg={isError ? '#FDB2B2' : isLatest ? '#000000' : '#F5F5ED'}
    borderWidth={1}
    borderColor={isError ? '#972626' : '#21211f'}
    borderRadius={20}
    style={{
      width: 40,
      height: 40,
    }}
  >
    {children}
  </Box>
)
export default DeliveryStatusIcon
